<template>
    <div v-if="items">
        <v-dialog
            v-model="dialog"
            max-width="400"
            persistent
        >
            <v-card>
                <v-card-title class="px-3">Select a merchant</v-card-title>
                <v-divider></v-divider>
                <v-text-field
                    v-model="search"
                    label="Search"
                    class="pa-3"
                    hide-details
                    clearable
                    clear-icon="mdi-close-circle-outline"
                    append-icon="mdi-magnify"
                ></v-text-field>
                <div class="tree-container">
                    <v-treeview
                        v-model="tree" 
                        :items="items"
                        :search="search"
                        activatable
                        item-key="id"
                        class="mt-2 pb-4"
                        :active.sync="select"
                        return-object
                        dense
                        ><template
                            slot="prepend"
                            slot-scope="{ item, open }">
                            <v-icon v-if="item.children">
                                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else>
                                {{ 'mdi-record' }}
                            </v-icon>
                        </template>
                    </v-treeview>
                </div>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="resetTree">Clear</v-btn>
                    <v-btn color="primary" @click="closeDialog">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        dialog: Boolean
    },
    data() {
        return {
            tree: [],
            items: [],
            search: null,
            uri: this.$store.state.sysState ? 'live' : 'test'
        }
    },
    beforeMount() {
        this.buildTree();
    },
    computed: {
        select: {
            get() {
                return this.tree;
            },
            set(v) {
                if(v) {
                    this.$emit('selectMerchant', v[0]);
                }
            }
        },
    },
    methods: {
        buildTree() {
            if(this.$store.state.user.user_role.id <= 3) {
                this.master();
            }
            else {
                this.client();
            }
        },
        master() {
            axios({
            method: 'get',
            url: `get-channels-${this.uri}`,
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                const keys = ["division", "merchant", "channel"];
                this.items = response.data
                    .reduce((r, o) => {
                        keys.reduce((t, k) => {
                            var temp = (t.children = t.children || []).find(p => p.id === o[k + 'Uuid']);
                            if (!temp) {
                                t.children.push(temp = { name: o[k + 'Name'], id: o[k + 'Uuid'] });
                            }
                            return temp;
                        }, r);
                        return r;
                    }, {})
                    .children;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        client() {
            axios({
            method: 'post',
            url: `get-channels-${this.uri}-client`,
            data: { userId: this.$store.state.user.id },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                const keys = ["division", "merchant", "channel"];
                this.items = response.data
                    .reduce((r, o) => {
                        keys.reduce((t, k) => {
                            var temp = (t.children = t.children || []).find(p => p.id === o[k + 'Uuid']);
                            if (!temp) {
                                t.children.push(temp = { name: o[k + 'Name'], id: o[k + 'Uuid'] });
                            }
                            return temp;
                        }, r);
                        return r;
                    }, {})
                    .children;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        closeDialog() {
            this.$emit('close', false);
        },
        resetTree() {
            this.$emit('resetTree', false);
            this.tree = [];
            this.select = [];
        }
    }
}
</script>

<style>
    .tree-container {
        display: inline-block;
        width: 400px;
        height: 350px;
        overflow: auto;
    }
    .v-treeview-node__label {
        font-size: 0.7rem !important;
        cursor: pointer;
    }

    .v-treeview--dense .v-treeview-node__root {
        min-height: 30px !important;
    }

    .v-treeview-node--active {
        background: none !important;
        color: #1976D2;
        font-weight: bold;
    }

    .v-treeview-node--active i {
        color: #1976D2 !important;
    }
</style>